import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelLs.mjs'

export const FormItemLsName = props => (
    <FormItemBizProp
        Model={Model}
        prop="lsName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseLs(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemLsName />
        </FormChooseDesign>
    )
}
